import JTopo from 'pangu-core/libs/jtopo-0.4.8'
// import contextmenu from "./contextmenu.js"
// import menuUtil from '../../../static/js/menuUtil.js'
// import arrayUtils from '../../../static/js/arrayUtils.js'

const defaultOptions = {
  routerData: '',
  orderCode: '',
  space: 200,
  disabled: true, // 是否只读
  vue: null,
  baseImageUrl: 'static/images/bissnessflow/',
  link: {
    arrowsRadius: 10, // 箭头大小
    lineWidth: 1, // 线宽
    bundleGap: 20, // 线条之间的间隔
    textOffsetY: 3, // 文本偏移量（向下3个像素）
    strokeColor: '90,195,0', // 线条颜色随机
    dashedPattern: 'dashedPattern',
  },
  scene: {
    backgroundColor: '234,241,236',
    background: '234,241,236',
    translateY: 20,
    translateX: 20,
  },
  node: {
    fontColor: '255,140,0',
    strokeColor: '#5ac300',
    nodeSpaceY: 150,
    nodeSpaceX: 200,
    width: 120,
    height: 80,
    active: {
      backgroundColor: '#5ac300',
      textColor: '#fff',
    },
    normal: {
      backgroundColor: 'transparent',
      textColor: '#a8a7a7',
    },
    iconFont: '28px Ionicons',
    bizName: '12px Ionicons',
  },
  layout: {
    type: 'tree',
    width: 180,
    height: 100,
    direction: 'right',
  },
  dataCopy: [],
}
class businessFlowUtil {
  constructor(divId, option = {}) {
    let canvas = divId
    if (typeof divId === 'string') {
      console.log("businessFlowUtil typeof divId == 'string'")
      canvas = document.getElementById(divId)
    }

    this.canvas = canvas
    this.options = Object.assign({}, defaultOptions, option)

    this.stage = null
    this.scene = null

    // 根节点
    this.rootNode = []
    // 已经设置过的节点ids
    this.hasSetLocationNodeIds = []

    // 用于判断，重叠
    var LocationRecord = {
      locationMap: {}, // "x_y":100_00
      lastY: 0,
      lastX: 0,
      _getKey: function (location) {
        // key="xy"+location.x+"_"+location.y;
        var key = location.y + '-' + location.x
        return key
      },
      // 是否该坐标已经存在。LocationRecord.isExistlocation(location);LocationRecord.setRecord(location);
      // this.locationRecord.isExistlocation(location);
      isExistlocation: function (location) {
        var key = this._getKey(location)
        return this.locationMap[key] == true
      },
      // 记录坐标
      // this.locationRecord.setRecord(location);
      setRecord: function (location) {
        var key = this._getKey(location)
        if (location.y > this.lastY) this.lastY = location.y
        if (location.x > this.lastX) this.lastX = location.x
        this.locationMap[key] = true
      },
    }

    this.locationRecord = LocationRecord
  } // end constructor
  // 场景添加右键事件

  creatStage(canvas) {
    let stage = new JTopo.Stage(canvas) // 创建一个舞台对象
    stage.wheelZoom = null // 设置鼠标缩放比
    return stage
  }

  creatScene(stage) {
    let scene = new JTopo.Scene(stage) // 创建一个场景对象
    scene.translateY = this.options.scene.translateY
    scene.translateX = this.options.scene.translateX
    scene.backgroundColor = this.options.scene.backgroundColor
    return scene
  }

  clearStage(stage) {
    stage.clear()
  }

  destroy() {
    if (this.stage) this.stage.clear()
    document.oncontextmenu = null
    this.canvas = null
    this.stage = null
    this.scene = null
    this.locationRecord = null
    this.rootNode = null
    this.options = null
    this.dataCopy = null
    // this.nodeList=null;
  }

  initData(data, orderCode, routerData) {
    // 初始化舞台
    if (this.stage) this.clearStage(this.stage)
    this.stage = this.creatStage(this.canvas)
    this.stage._id = orderCode

    // return;
    this.scene = this.creatScene(this.stage)

    // 初始化数据参数
    this.options.orderCode = orderCode
    this.options.routerData = routerData
    // this.dataCopy = [];
    // this.dataCopy = [...data];

    this.dataCopy = JSON.parse(JSON.stringify(data))

    for (var i = 0; i < this.dataCopy.length; i++) {
      this.dataCopy[i].orderFrom['nodeId'] = this.dataCopy[i].id
      this.dataCopy[i].orderFrom['bizCode'] = this.dataCopy[i].bizFrom.code
      this.dataCopy[i].orderFrom['orderCode'] = this.dataCopy[i].orderFrom.code
      this.dataCopy[i].orderFrom['bizname'] = this.handleSpecialName(this.dataCopy[i].bizFrom.name)
      this.dataCopy[i].orderFrom['icon'] =
        this.options.routerData[this.dataCopy[i].orderFrom.bizCode].icon

      this.dataCopy[i].orderTo['nodeId'] = this.dataCopy[i].id

      this.dataCopy[i].orderTo['bizname'] = this.handleSpecialName(this.dataCopy[i].bizTo.name)
      this.dataCopy[i].orderTo['bizCode'] = this.dataCopy[i].bizTo.code
      this.dataCopy[i].orderTo['orderCode'] = this.dataCopy[i].orderTo.code
      this.dataCopy[i].orderTo['icon'] =
        this.options.routerData[this.dataCopy[i].orderTo.bizCode].icon
    }

    // 循环节点,生成树
    this.createTree()
  }
  // 处理名称的括号
  handleSpecialName(name) {
    let index1 = name.indexOf('(')
    let index2 = name.indexOf('（')
    if (index1 > -1) {
      return name.substring(0, index1)
    }
    if (index2 > -1) {
      return name.substring(0, index2)
    }
    return name
  }
  //
  createTree() {
    if (!this.dataCopy && this.dataCopy <= 0) return

    var nodeList = []
    // 画节点
    for (var i = 0; i < this.dataCopy.length; i++) {
      var orderNode = this.dataCopy[i]
      var node = null
      // console.warn("orderNode.parentKey",orderNode.orderFrom.bizname,orderNode.orderTo.bizname);
      if (!this.getNodeByCode(orderNode.orderFrom.id)) {
        if (!i) orderNode.orderFrom['isLocation'] = true
        node = this.drawFlowNode(orderNode.orderFrom)
        if (node) nodeList.push(node)
      }
      if (!this.getNodeByCode(orderNode.orderTo.id)) {
        node = this.drawFlowNode(orderNode.orderTo)
        if (node) nodeList.push(node)
      }
      if (
        !this.getNodeByCode(orderNode.orderFrom.id) &&
        !this.getNodeByCode(orderNode.orderTo.id)
      ) {
        console.log(orderNode.orderFrom)
      }
    }

    // 画节点连线
    // eslint-disable-next-line no-redeclare
    for (var i = 0; i < this.dataCopy.length; i++) {
      this.addLinkByNode(this.dataCopy[i])
    }

    // 布局
    // this.nodeList = nodeList;
    // eslint-disable-next-line no-redeclare
    for (var i = 0; i < nodeList.length; i++) {
      // eslint-disable-next-line no-redeclare
      var orderNode = nodeList[i]
      // console.warn("orderNode.parentKey",orderNode.parentKey,orderNode.data.bizname,orderNode.data.bizname);
      if (!orderNode.parentKey || orderNode.parentKey.length == 0) {
        this.rootNode.push(orderNode)
      }
    }

    if (this.rootNode.lenght <= 0 && nodeList.length > 0) {
      console.warn('无根节点取第1个')
      this.rootNode.push(nodeList[0])
    }

    // 根据root节点，依次设置子孙后代的节点位置
    for (let i = 0; i < this.rootNode.length; i++) {
      this.rootNode[i].y = i ? this.options.node.nodeSpaceY + parseInt(this.getCurMaxY(), 10) : 0
      this.setLocationOfSceneNodeByRootNode(nodeList, this.rootNode[i])
    }

    // let maxHeight = this.options.vue.autoHeight;

    this.canvas.height = this.options.node.nodeSpaceY + parseInt(this.getCurMaxY(), 10)
    /**
            // 内存泄漏
            // this.options.vue.autoHeight = (this.options.node.nodeSpaceY + parseInt(
            //   this.getCurMaxY(), 10)).toString(); //高度自适应
             */
  }

  getCurMaxY() {
    let maxHeight = 100
    for (let item of this.stage.childs[0].childs) {
      if (item.elementType == 'node') {
        if (maxHeight < item.y) {
          maxHeight = item.y
        }
      }
    }
    return maxHeight
  }

  findNodesByParentKey(nodeList, key) {
    var children = []
    for (var i = 0; i < nodeList.length; i++) {
      var orderNode = nodeList[i]
      if (orderNode.parentKey && orderNode.parentKey.indexOf(key) > -1) {
        children.push(orderNode)
      }
    }
    return children
  }

  setLocationOfSceneNodeByRootNode(nodeList, parentNode) {
    var children = this.findNodesByParentKey(nodeList, parentNode.data.id)
    var isFirstNode = true
    for (var i = 0; i < children.length; i++) {
      var node = children[i]

      if (this.hasSetLocationNodeIds.indexOf(node.data.id) > -1) {
        continue
      }

      var nextY = parentNode.y

      if (isFirstNode) {
        isFirstNode = false
        nextY = parentNode.y
      } else {
        nextY = this.locationRecord.lastY + this.options.node.nodeSpaceY
      }

      var locaionObj = {
        x: parentNode.x + this.options.node.nodeSpaceX, // Node初始位置定为以父节点x右移动200px
        y: nextY,
      }
      // 判断位置是否重复
      locaionObj = this.getNextLocation(locaionObj, parentNode, node.data.id)

      node.x = locaionObj.x
      node.y = locaionObj.y

      this.locationRecord.setRecord(locaionObj)

      this.setLocationOfSceneNodeByRootNode(nodeList, node)
    }
  }

  getNextLocation(locaionObj, parentNode, nodeId) {
    if (this.locationRecord.isExistlocation(locaionObj)) {
      locaionObj.y += this.options.node.nodeSpaceY // Node初始位置定为以父节点x右移动200px;
      // console.log("locaionObj.y",locaionObj.y,locaionObj.x,this.locationRecord);
      return this.getNextLocation(locaionObj, parentNode, nodeId)
    }
    return locaionObj
  }

  // 添加2个节点得链接
  addLinkByNode(node) {
    // 有上级就添加链接
    if (node.orderFrom) {
      var nodeA = this.getNodeByCode(node.orderFrom['id'])
      var nodeB = this.getNodeByCode(node.orderTo['id'])
      if (nodeA && nodeB) this.addLink(nodeA, nodeB)
    }
  }

  addNodeMmousemove(node) {
    let that = this

    // addEventListener

    this.stage.eventsManage.addEventListener(node, 'mousemove', function () {
      that.canvas.style.cursor = 'pointer'
    })

    // node.mousemove(function(e) {
    //   that.canvas.style.cursor = "pointer";
    // });
  }

  // 绘制节点到画布
  drawFlowNode(nodeData) {
    var node = new JTopo.Node(nodeData.code)
    node.fontColor = this.options.node.fontColor
    node.width = this.options.node.width
    node.height = this.options.node.height
    let that = this
    node.paint = function (g) {
      g.beginPath()
      g.moveTo(-20, 40)
      g.lineWidth = that.options.link.lineWidth
      g.strokeStyle = that.options.node.strokeColor
      g.arc(-20, 0, 40, 0.5 * Math.PI, 1.5 * Math.PI, 0)
      g.lineTo(20, -40)
      g.arc(20, 0, 40, 1.5 * Math.PI, 0.5 * Math.PI, 0)
      g.lineTo(-20, 40)
      g.stroke()
      if (that.options.orderCode === nodeData.orderCode) {
        // 点亮当前单据
        g.fillStyle = that.options.node.active.backgroundColor
        g.fill()
        g.fillStyle = that.options.node.active.textColor
      } else {
        g.fillStyle = that.options.node.normal.backgroundColor
        g.fill()
        g.fillStyle = that.options.node.normal.textColor
      }
      g.font = that.options.node.iconFont
      g.fillText(nodeData.icon, -15, 0)
      g.moveTo(15, 0)
      g.font = '12px Ionicons'
      var textWidth2 = g.measureText(nodeData.bizname).width
      g.fillText(nodeData.bizname, -Math.floor(textWidth2 / 2), 20)
      this.paintText(g)
    }
    node.fillColor = '#fcae66'
    node.layout = this.options.layout
    node.setLocation(0, 0)
    node.data = nodeData
    node['location'] = this.scene.childs.length
    this.addClickEvent(node) // 为绘制的节点，添加点击事件
    this.addNodeMmousemove(node)
    this.scene.add(node)
    return node
  }

  // 为当前节点增加事件
  addClickEvent(node) {
    let that = this

    this.stage.eventsManage.addEventListener(node, 'click', function () {
      if (that.options.click) {
        that.options.click(this.data)
      }
      //
      // let routerDetail = that.options.routerData[this.data.bizCode];
      // if (routerDetail.routeFunction && that.options.vue.$customGoRouter) {
      //   that.options.vue.$customGoRouter[routerDetail.routeFunction](this
      //     .data, that.options.vue);
      // } else {
      //   let tempQuery = Object.assign({}, routerDetail.param);
      //   tempQuery.id = this.data.id;
      //   that.options.vue.$router.push({
      //     name: routerDetail.name,
      //     query: tempQuery
      //   });
      // }
    })

    // node.addEventListener('click', function(event){
    //     let routerDetail = that.options.routerData[this.data.bizCode];
    //     if(routerDetail.routeFunction && that.options.vue.$customGoRouter){
    //       that.options.vue.$customGoRouter[routerDetail.routeFunction](this.data,that.options.vue);
    //     }else{
    //       let tempQuery = Object.assign({},routerDetail.param);
    //       tempQuery.id = this.data.id;
    //       that.options.vue.$router.push({
    //         name: routerDetail.name,
    //         query: tempQuery
    //       });
    //     }
    // });
  }

  // 寻找当前绘制节点与重合节点X相同得父元素节点
  searchRepeatParentNode(node, x) {
    let parentNode = this.getNodeByCode(node)
    if (parentNode.x === x && !parentNode.isLocation) {
      return parentNode
    } else {
      this.searchRepeatParentNode(parentNode.data.id, x)
    }
  }

  // locaionObj 用于比较的y值，nodeId，不能挪动的节点，curNode 当前的节点
  setNodesLocation(locaionObj, nodeId) {
    var tempArr = this.scene.childs
    for (var i = 0; i < tempArr.length; i++) {
      if (tempArr[i].elementType != 'node') return
      if (nodeId === tempArr[i].data.id) continue
      if (tempArr[i].y >= locaionObj) {
        tempArr[i].y += 150
      }
    }
  }

  getNodeByCode(key) {
    var scene = this.stage.childs[0]

    var nodes = scene.childs.filter(function (e) {
      return e instanceof JTopo.Node && e.data['id'] == key
    })
    if (nodes && nodes.length > 0) return nodes[0]

    return null
  }

  // 添加2个节点得链接
  // eslint-disable-next-line no-dupe-class-members
  addLinkByNode(event1) {
    // 有上级就添加链接
    if (event1.orderFrom) {
      var nodeA = this.getNodeByCode(event1.orderFrom['id'])
      var nodeB = this.getNodeByCode(event1.orderTo['id'])
      if (nodeA && nodeB) this.addLink(nodeA, nodeB)
    }
  }

  getLinkByKey(name) {
    var scene = this.stage.childs[0]

    var nodes = scene.childs.filter(function (e) {
      return e instanceof JTopo.Link && e.key == name
    })
    if (nodes && nodes.length > 0) return nodes[0]

    return null
  }
  // 添加2个节点得链接
  addLink(nodeA, nodeZ) {
    var key = nodeA.data['id'] + '-' + nodeZ.data['id']
    // 连线之添加一次
    if (this.getLinkByKey(key)) {
      //  console.log(key);
      return
    }
    this.newFoldLink(nodeA, nodeZ)
  }

  // 画折线
  newFoldLink(nodeA, nodeZ) {
    var link = new JTopo.FlexionalLink(nodeA, nodeZ)
    link.arrowsRadius = 10
    link.nodeA = nodeA
    link.nodeZ = nodeZ
    nodeA.key = nodeA.data['id']

    if (!nodeZ.parentKey) nodeZ.parentKey = []
    if (!nodeA.childKey) nodeA.childKey = []
    nodeZ.parentKey.push(nodeA.key) // 多个父类时，都记录解决布局bug。
    nodeA.childKey.push(nodeZ.key) // 多个父类时，都记录解决布局bug。
    link.direction = 'horizontal'
    link.strokeColor = '90,195,0' // 连线之间的颜色
    link.lineWidth = 1 // 线段的粗细
    this.scene.add(link)
  }
}

export default businessFlowUtil
